import { render, staticRenderFns } from "./index-apps.vue?vue&type=template&id=04803d7e&"
import script from "./index-apps.vue?vue&type=script&lang=js&"
export * from "./index-apps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports